import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { SessionManager, getConfig } from "../../../../utils";

export const updateBranchCourse = createAsyncThunk('updateBranchCourse', async (data) => {
    try {
        const res = await axios({
            method: 'PUT',
            url: getConfig.API_URL + 'branch_course',
            data: {
                "id": data?.values?.id,
                "institute_id": data?.values?.instituteId,
                "institute_branch_id": data?.values?.instituteBranchId,
                "course_id": data?.values?.courseId,
                "status": data?.values?.status,
            },
            headers: { "Content-Type": "application/json", "Authorization": SessionManager.getCookie("user_token") }
        })
        return res
    } catch (error) {
        return error.response
    }
})
